import React from 'react';
import { Card, CardText } from 'react-toolbox/lib/card';
import Input from 'react-toolbox/lib/input';
import { TitleBar } from '../../../../common/components/Layout/StandardPageTemplate/Context';
import { ImageCard, TextCard, ActionButton, IssueItem } from '../Elements';
import objectToArray from '../../../../common/utils/object-to-array';
import { LOCATION_ORIGIN } from '../../../../common/call-api';
import glamorous from 'glamorous';
const { Div } = glamorous;

const emptyPageTemplate = {
  media: {},
  issues: [{ text: '' }, { text: '' }, { text: '' }],
  text: '',
  actionBtn: {},
};

const Section = (EditComponent, PreviewComponent) => props => {
  return (
    <Div display="flex" flexDirection="row">
      <Card style={{ margin: '0 1rem 2rem 0' }}>
        <CardText>
          <EditComponent {...props} />
        </CardText>
      </Card>
      <Div style={{ margin: '0 0 2rem 1rem', minWidth: '40%' }}>
        <PreviewComponent {...props} />
      </Div>
    </Div>
  );
};

const UrlPreview = ({ value = '' }) => (
  <Card>
    <CardText>
      <span>
        {LOCATION_ORIGIN.replace(/\/$/, '')}/join/{value}
      </span>
    </CardText>
  </Card>
);

const ButtonEdit = ({ label, value: props = {}, onChange }) => {
  const handleEdit = key => value => onChange({ ...props, [key]: value });
  return (
    <Div>
      <h2>{label}</h2>
      <Input label="Label" value={props.label} onChange={handleEdit('label')} />
      <Input
        type="color"
        label="Background"
        value={props.backgroundColor}
        onChange={handleEdit('backgroundColor')}
      />
      <Input
        type="color"
        label="Text Color"
        value={props.color}
        onChange={handleEdit('color')}
      />
    </Div>
  );
};

const ActionButtonPreview = ({ value = {} }) => (
  <ActionButton
    {...value}
    style={{
      fontSize: '2.6rem',
      lineHeight: '2.6rem',
      padding: '2rem 3rem',
      height: 'auto',
    }}
  />
);

const TextCardPreview = ({ value = '' }) => (
  <Div maxWidth={450}>
    <TextCard>{value}</TextCard>
  </Div>
);

const IssueEdit = ({ issue = {}, onChange }) => {
  const handleEdit = key => value => onChange({ ...issue, [key]: value });
  return (
    <Div>
      <Input label="Icon" value={issue.icon} onChange={handleEdit('icon')} />
      <Input
        type="color"
        label="Background"
        value={issue.backgroundColor}
        onChange={handleEdit('backgroundColor')}
      />
      <Input
        type="color"
        label="Icon Color"
        value={issue.color}
        onChange={handleEdit('color')}
      />
      <Input label="Title" value={issue.title} onChange={handleEdit('title')} />
      <Input
        label="Text"
        multiline
        value={issue.text}
        onChange={handleEdit('text')}
      />
    </Div>
  );
};

const IssuePreview = ({ issue = {} }) => {
  return (
    <Div maxWidth={400}>
      <IssueItem {...issue} />
    </Div>
  );
};

const ImageEditInput = ({ value = {}, onChange }) => {
  return (
    <Input
      value={value.source}
      onChange={val => onChange({ ...value, source: val })}
    />
  );
};

export default class AdminPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: props.page,
      sections: {
        key: { Component: Section(Input, UrlPreview), label: 'Path' },
        media: {
          Component: Section(ImageEditInput, ImageCard),
          label: 'Media',
          multiline: true,
        },
        text: {
          Component: Section(Input, TextCardPreview),
          label: 'Text',
          multiline: true,
        },
        issues: {
          Component: Section(IssueEdit, IssuePreview),
          label: 'Issues',
        },
        actionBtn: {
          Component: Section(ButtonEdit, ActionButtonPreview),
          label: 'Button',
        },
      },
    };
  }

  componentWillMount() {
    window.exportPage = this.exportPage;
  }

  componentWillUnmount() {
    window.exportPage = null;
  }

  handleChange = name => value => {
    this.setState(({ page: prevPage }) => ({
      page: {
        ...prevPage,
        [name]: value,
      },
    }));
  };

  handleArrayChange = (state = [], index) => value => {
    const newList = state.slice(0);
    newList[index] = value;
    return newList;
  };

  renderSection = ({ Component, key, ...rest }) => {
    const value = (this.state.page || emptyPageTemplate)[key];
    if (Array.isArray(value)) {
      const handleChange = (key, index) => val =>
        this.handleChange(key)(this.handleArrayChange(value, index)(val));
      return value.map((v, i) => (
        <Component
          key={`${key}_${i}`}
          {...rest}
          issue={v}
          onChange={handleChange(key, i)}
        />
      ));
    }
    return (
      <Component
        key={key}
        {...rest}
        value={value}
        onChange={this.handleChange(key)}
      />
    );
  };

  exportPage = () => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(this.state.page));
  };

  render() {
    const sections = objectToArray(this.state.sections);
    return (
      <Div>
        <TitleBar title="Antman Template Page Admin" />
        {sections.map(this.renderSection)}
      </Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/join/Templates/Antman/Admin.js